module.exports = __webpack_public_path__ + "static/img/img-05.487c86a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-05.jpg
// module id = 88
// module chunks = 0